import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import DynamicForm from "../Dynamic-Form/dynamic-form"

function FormModal({ title, subTitle, actionButtons, formData, formCallback }) {
  const submitButtonId = "form-modal-submit"
  const [formValid, setFormValid] = useState(false)
  const lastButtonText = useRef(null)

  const formCallbackWithContext = ({ state, values }) => {
    formCallback({ formState: state, formValues: values, lastButtonPressed: lastButtonText.current })
  }

  const handleFormSubmit = () => {
    const formSubmitBtn = document.getElementById(submitButtonId)
    formSubmitBtn.click()
  }

  return (
    <div className="form-modal-content">
      <h3 className="modal-title">{title}</h3>
      <p className="modal-subtitle">{subTitle}</p>
      <div className="modal-form-wrapper">
        <DynamicForm formData={formData} setFormValid={setFormValid} submitButtonId={submitButtonId} submitCallback={formCallbackWithContext} />
      </div>
      <div className="modal-action-wrapper">
        {actionButtons.map((button, btnIndex) => (
          <button
            key={`info-btn-${btnIndex}`}
            className={`btn ${button.classNames.join(" ")}`}
            onClick={() => {
              if (button.requiresValidation) {
                if (formValid) {
                  lastButtonText.current = button.text
                  handleFormSubmit()
                  button.clickHandler()
                }
              } else {
                lastButtonText.current = button.text
                handleFormSubmit()
                button.clickHandler()
              }
            }}
          >
            {button.text}
          </button>
        ))}
      </div>
    </div>
  )
}

FormModal.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      classNames: PropTypes.array,
      requiresValidation: PropTypes.bool,
      clickHandler: PropTypes.func,
    })
  ).isRequired,
  formData: PropTypes.object.isRequired,
  formCallback: PropTypes.func,
}

export default FormModal
